export default {
  noData: 'Keine weiteren Daten verfügbar',
  delConfirmTips: 'Möchten Sie die ausgewählten Daten wirklich löschen?',
  delSuccess: 'Erfolgreich gelöscht',
  tips: 'Hinweise',
  add: 'Hinzufügen',
  edit: 'Bearbeiten',
  del: 'Löschen',
  editSuccess: 'Erfolgreich geändert',
  activeAccount: 'Konto aktivieren',
  mailActiveSuccess: 'Kontoaktivierung erfolgreich',
  back: 'Zurück',
  goLogin: 'Zum Login',
  email: 'E-Mail',
  emailSendSuccess: 'E-Mail erfolgreich gesendet',
  paySuccess: 'Zahlung erfolgreich',
  action: 'Aktion',
  logoutSuccess: 'Erfolgreich abgemeldet',
  plsUpload: 'Bitte hochladen',
  upload: 'Hochladen',
  file: 'Datei',
  uploadFail: 'Hochladen fehlgeschlagen',
  uploadSuccess: 'Hochladen erfolgreich',
  pay: 'Bezahlen',
  day: 'Tag',
  servePrice: 'Servicegebühr',
  skillServePrice: 'Technische Servicegebühr',
  unitMonth: 'Monat(e)',
  num: 'Anzahl',
  photo: 'Foto',
  product: 'Produkt',
  sizeHaveUnit: 'Größe (cm)',
  weightHaveUnit: 'Gewicht (g)',
  fee: 'Gebühr',
  free: 'Kostenlos',
  submitTime: 'Einreichungszeit',
  weight: 'Gewicht',
  cancelReason: 'Stornierungsgrund',
  submitPackage: 'Paket einreichen',
  submitSuccess: 'Einreichung erfolgreich',
  price: 'Preis',
  status: 'Status',
  noProduct: 'Keine Produkte',
  backEdit: 'Zurück zur Bearbeitung',
  errorHint: 'Schnittstellenfehler, bitte versuchen Sie es erneut',
  reload: 'Neu laden',
  reloadPageTips:
    'Sie haben ein Konto gewechselt. Bitte laden Sie die Seite neu, um aktualisierte Informationen zu erhalten.',
  cancel: 'Abbrechen',
  noMsg: 'Keine Informationen',
  totalAmount: 'Gesamtbetrag',
  see: 'Ansehen',
  confirm: 'Bestätigen',
  send: 'Senden',
  nowNoInfo: 'Derzeit keine Informationen',
  genderEnum: {
    0: 'Männlich',
    1: 'Weiblich',
  },
  goEmailActiveTips: 'Bitte gehen Sie zu Ihrer E-Mail, um Ihr Konto zu aktivieren!',
  holder: {
    inputRemark: 'Bitte geben Sie eine Bemerkung ein',
    inputExplainCancelReason: 'Bitte begründen Sie den Stornierungsgrund',
    inputAddAddress: 'Bitte geben Sie die Lieferadresse ein',
    inputMsg: 'Bitte geben Sie eine Nachricht ein',
  },
  acceptMsg:
    'Diese Website speichert Cookies auf Ihrem Computer, um Ihnen ein besseres Erlebnis zu bieten. Weitere Informationen finden Sie in unserer Datenschutzerklärung.',
  accept: 'Akzeptieren',
  refuse: 'Ablehnen',
  notice: 'Hinweis',
  noticeMsg: 'Neue Logistiklinie, 10% Preisreduzierung',
  english: 'Englisch',
  spanish: 'Spanisch',
  french: 'Französisch',
  chinese: 'Chinesisch',
  copySuccess: 'Erfolgreich kopiert',
  copyError: 'Kopieren fehlgeschlagen',
  noAgainShow: 'Nicht erneut anzeigen',
  download: 'Herunterladen',
  downloadSuccess: 'Download erfolgreich',
  uploadImgTips: 'Bitte laden Sie JPG/PNG/WEBP/JPEG-Dateien hoch',
  noCheckAboutAgree: 'Zustimmung zu den Bedingungen nicht angekreuzt',
  country: 'Land',
  collectSuccess: 'Erfolgreich gespeichert!',
  cancelCollectSuccess: 'Speichern erfolgreich abgebrochen!',
  formatError: 'Formatfehler, zum Beispiel: {formatStr}',
  volume: 'Volumen (cm³)',
  notRequired: 'Nicht erforderlich',
  productSaleCount: 'Verkäufe',
  searchPlaceholder: 'Bitte geben Sie den Suchbegriff ein',
  THEME_MODE: 'Themenmodus',
  FOLLOW_SYSTEM: 'System folgen',
  DAY_MODE: 'Tagmodus',
  NIGHT_MODE: 'Nachtmodus',
}
